import LOGO_1 from './wallstreet.png'


export const assets = {
    LOGO_1
}   